import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { MeetOurTeamCompWrapper } from "../../styles/StyledComponents/MeetOurTeamCompWrapper";
import { teamsCardMock } from "../../ui/json/demo.mock";
import CommonHeading from "../CommonHeading/CommonHeading";
import TeamsCardSec from "../TeamsCardSec/TeamsCardSec";


const MeetOurTeamComp = () => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.6,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <MeetOurTeamCompWrapper className="cmn_gap">
      <div className="container">
        <CommonHeading
          className="meet_our_teams_heading"
          isPrimary
          title="Meet Our Team"
          paratext="Behind every great website we build is a team of dedicated designers, developers, and creatives. We work collaboratively, combining our unique skills to deliver results that exceed expectations."
        />
        <div className="row teamsCardRow">
          {teamsCardMock?.map((data, index) => (
            <div className="teamsCard_col" key={index}>
              <TeamsCardSec {...data} />
            </div>
          ))}
        </div>
        <div className="slider_teams_card">
          <Slider {...settings}>
            {teamsCardMock?.map((data, index) => (
              <div className="teamsCard_col" key={index}>
                <TeamsCardSec {...data} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </MeetOurTeamCompWrapper>
  );
};

export default MeetOurTeamComp;
